import { TemplatesResponse } from "../models/types";
import { fetchWithAuth } from "../utils/auth";

export const readTemplates = async (): Promise<TemplatesResponse> => {
    try {
      const fetchUrl = `/api/backend/templates`;
      const res = await fetchWithAuth(fetchUrl, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.status >= 400 && res.status < 600) {
        throw new Error("Server not returned a valid response");
      }
      const resJson = await res.json();
      return new TemplatesResponse({ data: resJson.templates });
    } catch (error) {
      let message;
      if (error instanceof Error) {
        message = error.message;
      } else {
        message = "Unable to load ticket";
      }
      return new TemplatesResponse({ error: message });
    }
  };